import { LoadableElement } from '@99designs/common/components/LoadableElement';
import { Create } from '__generated__/Create';
import { getLocale } from 'common/utils/getLocale';
import { getRoleFromUser } from 'common/utils/getRole';
import { loadIntlDataForLocale } from 'common/utils/intl';
import { AuthProvider } from 'projects/components/AuthContext';
import CreateContext from 'projects/components/CreateContext';
import ErrorBoundary from 'projects/components/ErrorBoundary';
import Routes from 'projects/routes';
import * as React from 'react';
import { ApolloProvider, Query } from 'react-apollo';
import * as ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import client from './client';
import query from './create.graphql';
import BrowserRouter from './routes/BrowserRouter';

import 'common/polyfill';

// Async ()
// Remove me
// tslint:disable:no-floating-promises
(async () => {
    await loadIntlDataForLocale(getLocale());

    ReactDOM.render(
        <ApolloProvider client={client}>
            <ErrorBoundary>
                <Query<Create> query={query}>
                    {({ loading, error, data }) => {
                        if (loading)
                            return <LoadableElement isLoading={true} variations={['relative ']} />;
                        if (error) throw error;
                        if (data) {
                            return (
                                <CreateContext.Provider
                                    value={{
                                        site: data.site,
                                        role: getRoleFromUser(data.viewer.user),
                                    }}
                                >
                                    <IntlProvider locale={getLocale()}>
                                        <AuthProvider user={data.viewer.user}>
                                            <ErrorBoundary>
                                                <BrowserRouter>
                                                    <Routes />
                                                </BrowserRouter>
                                            </ErrorBoundary>
                                        </AuthProvider>
                                    </IntlProvider>
                                </CreateContext.Provider>
                            );
                        }
                        return null;
                    }}
                </Query>
            </ErrorBoundary>
        </ApolloProvider>,
        document.querySelector('[data-app]')
    );
})();
